import { Route, Redirect } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { selectAuth } from "../store/slices/auth";
import { useAuth } from "../Hooks/useAuth";
import { logger } from "../functions/logger";
import { localStorageAuthv2, localPouchPrefix } from "../config";
import FullLoadingScreen from "@shared/components/FullLoadingScreen";

// The redirect below is an INVOLUNTARY logout as the collector experiences it:
// she is dropped on the login screen without pressing anything. It was the one
// unexplained path with no record at all, so it is logged here.
//
// The useful part is `has_stored_auth`, which splits the two causes that look
// identical from the outside:
//   true  -> `cobro_auth` is STILL in localStorage but auth state says jwt=null,
//            i.e. we failed to load our own session (app bug).
//   false -> localStorage was cleared under us (browser/OS storage eviction,
//            "clear site data", private mode). Nothing app-side lost it.
//
// Module-scoped flag: this runs inside a render prop, so a re-render or a second
// protected route would otherwise write the same record many times.
let sessionMissingLogged = false;

const ProtectedRoute = ({ component: Component, render, ...rest }) => {
  const { data, isLoading } = useAuth();

  if (isLoading) return <FullLoadingScreen />;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (data.jwt === null) {
          if (!sessionMissingLogged) {
            sessionMissingLogged = true;
            logger.warning("auth.session_missing", "No JWT in auth state; redirecting to login", {
              entity: "auth",
              context: {
                from: props.location?.pathname ?? null,
                has_stored_auth: !!localStorage.getItem(localStorageAuthv2),
                has_prefix: !!localStorage.getItem(localPouchPrefix),
                has_cuadre_id: !!localStorage.getItem("localCommonId"),
              },
            });
          }

          return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
        } else {
          return Component ? <Component {...props} /> : render(props);
        }
      }}
    />
  );
};

export default ProtectedRoute;
